require('./style.less');

var Marionette = require('marionette'),
    PreventDragEventsMixin = require('../preventDragEventsMixin');


/**
 * A simple view displaying an error message that is appended to pages that load in error.
 */

module.exports = Marionette.ItemView.extend({

    className: 'pageLoadError',

    template: require('./template'),

    serializeData: function() {

        var errMsg = this.options.errMsg;

        errMsg = _.isString(errMsg)
            ? errMsg
            : 'Error Loading Image'; //Generic Error if not from CRE

        return {
            errMsg: errMsg
        };

    },

    // Allow user to select and copy the text
    // TODO: need  only over the text -- want to allow drag on the page itself
    events: PreventDragEventsMixin

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/error/view.js
 ** module id = 436
 ** module chunks = 0
 **/